import React, { useEffect, useState } from 'react';
import 'video-react/dist/video-react.css';
import './styles.js';
import MoovPlayer from './moov-player';
import { Back, Container } from './styles.js';
import { useNavigate } from 'react-router-dom';

const Watch = ( { movie_type, movie_id, movie_id_imdb, season, episode, episodes, watch_data, setWatchData, watch_data_watching, movieData } ) => {

  const navigate = useNavigate();

  const [ nextEpisode, setNextEpisode ] = useState(null);

  useEffect(()=> {

    if (!watch_data) {
      navigate(`/details/${movie_type}/${movie_id}/${movie_id_imdb}`)
    }

  }, [ watch_data ]);

  useEffect(() => {
    if (episodes?.length > 0 && watch_data?.season_episode) {
      const nextEpisodeData = episodes?.find(
        (ep) => Number(ep?.season_episode) === (Number(watch_data?.season_episode) + 1)
      );
  
      setNextEpisode(nextEpisodeData);

      if (nextEpisodeData?.season_episode) {
        console.log("Há um próximo episódio")
      }
    }

  }, [episodes, watch_data]);

  return (
    <Container>
      <MoovPlayer
        navigate={navigate}
        next_episode={nextEpisode}
        movie_data={movieData}
        watch_data={watch_data}
        setWatchData={setWatchData}
        watch_data_watching={watch_data_watching}
      />
    </Container>
  );
};

export default Watch;
